import apiRoutes from './api.routes';
import ModelService from './model.service';

const BlogPostService = new ModelService(apiRoutes.blogPost, '/blog-post');
BlogPostService.modelName = 'BlogPost';
export default BlogPostService;



// WEBPACK FOOTER //
// ./src/services/blogPost.service.js